import React from "react";
import { Controller } from "react-hook-form";

import DatePicker from "@/components/Atoms/Inputs/DatePicker";
import ErrorUI from "@/components/Atoms/ErrorUI";

import { InputGroupV3, InputWrapperV3 } from "../style";

const DateInput = ({
  name,
  control,
  showLabels,
  datePlaceholder,
  isNotAbsolute,
  ...rest
}) => (
  <InputWrapperV3>
    <InputGroupV3 hasBottomBorder showLabels={showLabels}>
      <Controller
        name={name}
        control={control}
        shouldUnregister
        render={({
          field: { value, onBlur, onChange, ref },
          fieldState: { error },
        }) => (
          <>
            <DatePicker
              innerRef={ref}
              placeholder={datePlaceholder}
              name={name}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              {...rest}
            />
            {error && (
              <ErrorUI
                hasBottomBorder
                error={error?.message}
                isNotAbsolute={isNotAbsolute}
              />
            )}
          </>
        )}
      />
    </InputGroupV3>
  </InputWrapperV3>
);

export default DateInput;
